import { Navigate, generatePath } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_PLAY,
  NBA_GAMES_GAMEID_EVENTTYPE,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './$eventType/__generated__/routeParams';

const GamePage = () => {
  const { gameId, eventType } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();
  if (!gameId) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} replace />;
  }
  return (
    <Navigate
      to={generatePath(NBA_GAMES_GAMEID_EVENTTYPE, {
        gameId,
        eventType: eventType || So5FixtureEvent.CLASSIC,
      })}
      replace
    />
  );
};

export default GamePage;
